import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const RepresentativeHeader = ({ onCreateClick }) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h4" component="h1">
                {t('representatives.title')}
            </Typography>
            <Button variant="contained" startIcon={<AddIcon />} onClick={onCreateClick}>
                {t('representatives.addNew')}
            </Button>
        </Box>
    );
};

export default RepresentativeHeader;